(() => {
  'use strict';

  if (window.__STRYKR_HEADER_CART_OPEN_20260528__) return;
  window.__STRYKR_HEADER_CART_OPEN_20260528__ = true;

  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const sectionUrl = (ids) => {
    const url = new URL(rootPath(), window.location.origin);
    url.searchParams.set('sections', ids.join(','));
    return url.toString();
  };

  const replaceSection = (id, html) => {
    if (!html) return;
    const nextDoc = new DOMParser().parseFromString(html, 'text/html');
    const next = nextDoc.getElementById(`shopify-section-${id}`) || nextDoc.getElementById(id);
    const current = document.getElementById(`shopify-section-${id}`) || document.getElementById(id);
    if (current && next) current.innerHTML = next.innerHTML;
  };

  const refreshDrawer = async () => {
    try {
      const response = await fetch(sectionUrl(['cart-drawer', 'cart-icon-bubble']), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return false;
      const sections = await response.json();
      replaceSection('cart-drawer', sections['cart-drawer']);
      replaceSection('cart-icon-bubble', sections['cart-icon-bubble']);
      return true;
    } catch (_) {
      return false;
    }
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      try {
        drawer.close();
        return;
      } catch (_) {}
    }

    drawer.classList.remove('active', 'animate', 'is-open', 'open');
    drawer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
  };

  const ensureCartDrawerElement = () => {
    if (typeof window.removeTrapFocus !== 'function') window.removeTrapFocus = () => {};
    if (typeof window.trapFocus !== 'function') window.trapFocus = () => {};
    if (!window.customElements || window.customElements.get('cart-drawer')) return;

    window.customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      open() {
        this.classList.add('active');
        this.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active', 'animate', 'is-open', 'open');
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
      }
    });
  };

  const openDrawer = async (initialDrawer) => {
    ensureCartDrawerElement();
    await refreshDrawer();
    ensureCartDrawerElement();
    const drawer = document.querySelector('cart-drawer') || initialDrawer;
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    drawer.classList.add('active');
    drawer.classList.remove('is-empty');
    document.body.classList.add('overflow-hidden');
    return true;
  };

  document.addEventListener('click', (event) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || (!drawer.classList.contains('active') && !drawer.classList.contains('animate') && !drawer.classList.contains('is-open') && !drawer.classList.contains('open') && !drawer.hasAttribute('open'))) return;

    const target = event.target;
    if (!target || !target.closest) return;

    const closeTrigger = target.closest('.drawer__close, .cart-drawer__close, [data-drawer-close], button[aria-label*="close" i], button[aria-label*="fermer" i], button[aria-label*="schließen" i], button[aria-label*="schliessen" i]');
    const overlayTrigger = target.closest('#CartDrawer-Overlay, .cart-drawer__overlay, .drawer__overlay');
    const insideDrawer = target.closest('.drawer__inner, .cart-drawer__inner, cart-drawer-items, [data-drawer-content]');
    const implicitOverlay = target === drawer || (drawer.contains(target) && !insideDrawer && !target.closest('a, button, input, select, textarea, label'));
    if (!closeTrigger && !overlayTrigger && !implicitOverlay) return;

    event.preventDefault();
    event.stopPropagation();
    closeDrawer(drawer);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || (!drawer.classList.contains('active') && !drawer.classList.contains('animate') && !drawer.classList.contains('is-open') && !drawer.classList.contains('open') && !drawer.hasAttribute('open'))) return;
    closeDrawer(drawer);
  });

  document.addEventListener('click', (event) => {
    const link = event.target && event.target.closest && event.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], a[href$="/cart/"], [data-cart-link]');
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = link.getAttribute && link.getAttribute('href');
    if (href && /\/cart\/[\w%-]+:/.test(href)) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    event.preventDefault();
    openDrawer(drawer);
  }, true);
})();
